<template>
    <ds-chip slot="reference" class="merge-field-chip" :class="{ 'overflow-chip': isOverflow }">
        <template #leading>
            <ds-icon name="merge-field" class="merge-icon" />
        </template>

        {{ label }}
    </ds-chip>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true,
        },

        isOverflow: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
    .merge-field-chip {
        --chip-background-color: #{$color-blue-050};

        &.overflow-chip {
            --chip-background-color: #{$color-red-100};
        }
    }

</style>
